import templateUrl from "emun.vendor/vendor-dashboard-header.htm";
import controller from "emun.vendor/vendor-dashboard-header.controller";

export default {
  bindings: {
    vendor: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
